import { Button, ButtonProps } from '@mui/material';
/**
 * @deprecated Use `Button` with the `loading` prop set to `true` instead.
 */
export type LoadingButtonProps = ButtonProps;

/**
 * @deprecated Use `Button` with the `loading` prop set to `true` instead.
 */
export const LoadingButton = Button;

// eslint-disable-next-line deprecation/deprecation
export default LoadingButton;
